import { QueryHookOptions } from '@apollo/client'
import {
    B2CGetErrorFlowCheckoutSessionQuery,
    B2CGetErrorFlowCheckoutSessionQueryVariables
} from 'parkdepot-shared/gql/graphql'
import { useAuthenticatedQuery } from './useAuth'
import B2C_GET_ERROR_FLOW_CHECKOUT_SESSION from '@graphql/queries/getCarpayErrorFlowCheckoutSession.query'

const useGetErrorFlowCheckoutSession = (
    opts: QueryHookOptions<B2CGetErrorFlowCheckoutSessionQuery, B2CGetErrorFlowCheckoutSessionQueryVariables>
) => {
    return useAuthenticatedQuery({ query: B2C_GET_ERROR_FLOW_CHECKOUT_SESSION, ...opts })
}

export default useGetErrorFlowCheckoutSession
